import { useEffect } from 'react';
import { scrollToTop } from 'src/util/scroll';

export const useScrollToTop = (dependency?: any) => {
  useEffect(() => {
    scrollToTop();
  }, [dependency]);
};
